import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DynamicTable from "../../Components/Table/DynamicTable";
import { fetchProjects } from "../../Redux/WhatsappSlice/Project";
import { addVersion, fetchVersions } from "../../Redux/WhatsappSlice/Version";
import Loader from "../../Components/Loader/Loader";

const Add_Version = () => {
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear(); // Get the full 4-digit year
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const dispatch = useDispatch();

  const { ProjectData } = useSelector((state) => state.Project);
  const { VersionData } = useSelector((state) => state.Version);

  useEffect(() => {
    dispatch(fetchVersions());
    dispatch(fetchProjects());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    Project: "",
    Version: "",
    VersionDate: "",
  });

  const [errors, setErrors] = useState({});

  // const [showUpdateModal, setShowUpdateModal] = useState(false);
  // const [currentVersion, setCurrentVersion] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.Project) newErrors.Project = "Project is required.";
    if (!formData.Version) newErrors.Version = "Version number is required.";
    if (!formData.VersionDate)
      newErrors.VersionDate = "Version date is required.";
    return newErrors;
  };

  // const handleDelete = async (row) => {
  //   const isConfirmed = window.confirm(
  //     `Are you sure you want to delete version ${row.Version}?`
  //   );
  //   if (!isConfirmed) return;

  //   try {
  //     await dispatch(DeleteVersion({ id: row.MainId })).unwrap();
  //     toast.success("Version deleted successfully!", {
  //       position: "top-right",
  //       autoClose: 1000,
  //       hideProgressBar: false,
  //       closeOnClick: false,
  //       pauseOnHover: true,
  //     });
  //     dispatch(fetchVersions()); // refresh list
  //   } catch (error) {
  //     toast.error(`Failed to delete version: ${error}`, {
  //       position: "top-right",
  //       autoClose: 1000,
  //       hideProgressBar: false,
  //       closeOnClick: false,
  //       pauseOnHover: true,
  //     });
  //   }
  // };

  // const handleEditClick = (row) => {
  //   const matchedProject = ProjectData.find(
  //     (p) => p.ProjectName === row.Project
  //   );

  //   setCurrentVersion({
  //     _id: row.MainId,
  //     Project: matchedProject?._id || "",
  //     Version: row.Version,
  //     VersionDate: row.VersionDate
  //       ? new Date(row.VersionDate).toISOString().split("T")[0]
  //       : "",
  //   });

  //   setShowUpdateModal(true);
  // };

  // const handleUpdateSubmit = async (e) => {
  //   e.preventDefault();

  //   if (
  //     !currentVersion.Project ||
  //     !currentVersion.Version ||
  //     !currentVersion.VersionDate
  //   ) {
  //     toast.error("Please fill in all fields.", {
  //       position: "top-right",
  //       autoClose: 1000,
  //       hideProgressBar: false,
  //       closeOnClick: false,
  //       pauseOnHover: true,
  //     });
  //     return;
  //   }

  //   // Append time to the VersionDate
  //   const getCurrentTime = () => {
  //     const now = new Date();
  //     const hours = String(now.getHours()).padStart(2, "0");
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const seconds = String(now.getSeconds()).padStart(2, "0");
  //     return `${hours}:${minutes}:${seconds}`;
  //   };

  //   const versionDateWithTime = `${
  //     currentVersion.VersionDate
  //   } ${getCurrentTime()}`;

  //   const updatedData = {
  //     ...currentVersion,
  //     VersionDate: versionDateWithTime,
  //   };

  //   try {
  //     await dispatch(
  //       updateVersion({
  //         id: currentVersion._id,
  //         versionData: updatedData,
  //       })
  //     ).unwrap();

  //     toast.success("Version updated successfully!");
  //     setShowUpdateModal(false);
  //     setCurrentVersion(null);
  //     dispatch(fetchVersions());
  //   } catch (error) {
  //     toast.error("Failed to update version.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        await dispatch(addVersion({ values: formData })).unwrap();

        toast.success("Version added successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
        });

        // Reset form
        setFormData({
          Project: "",
          Version: "",
          VersionDate: "",
        });
        dispatch(fetchVersions());
      } catch (error) {
        toast.error(
          `Failed to add version: ${error.message || "Unknown error"}`,
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    { field: "Project", headerName: "Project Name", flex: 1 },
    { field: "Version", headerName: "Version", flex: 1 },
    { field: "VersionDate", headerName: "Version Date", flex: 1 },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <div className="flex space-x-2">
    //       <button
    //         className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
    //         onClick={() => handleEditClick(params.row)}
    //       >
    //         Update
    //       </button>
    //       <button
    //         className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
    //         onClick={() => handleDelete(params.row)}
    //       >
    //         Delete
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const rows =
    VersionData?.map((el, index) => ({
      id: index + 1,
      tokan: el?.CallNo,
      MainId: el._id,
      Project: el?.Project?.project_name,
      Version: el?.Version,
      VersionDate: formatDisplayDate(el?.VersionDate),
    })) || [];

  if (
    !ProjectData ||
    !VersionData
  ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Add Version
          </h3>
        </div>

        <div className="form_home Form_bg_color">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* Project Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Select Project</h5>
              <select
                name="Project"
                value={formData.Project}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              >
                <option value="">Select Project</option>
                {[...(ProjectData || [])]
                  .sort((a, b) => (a.project_name || "").localeCompare(b.project_name || ""))
                  .map((project) => (
                    <option key={project._id} value={project._id}>
                      {project.project_name}
                    </option>
                  ))}
              </select>
              {errors.Project && (
                <p className="text-red-500 text-sm mt-1">{errors.Project}</p>
              )}
            </div>

            {/* Version Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Version Number</h5>
              <input
                type="text"
                name="Version"
                placeholder="Enter version number"
                value={formData.Version}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Version && (
                <p className="text-red-500 text-sm mt-1">{errors.Version}</p>
              )}
            </div>

            {/* Version Date Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Version Date</h5>
              <input
                type="date"
                name="VersionDate"
                value={formData.VersionDate}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.VersionDate && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.VersionDate}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                Submit
              </button>
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
              Version List
            </h3>
          </div>
          <div className="bg-white shadow-md rounded-lg overflow-x-auto mt-5">
            <DynamicTable columns={columns} rows={rows} />
          </div>
        </div>

        {/* {showUpdateModal && currentVersion && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
              <h2 className="text-xl font-bold mb-4">Update Version</h2>
              <form onSubmit={handleUpdateSubmit} className="space-y-4">
                <div>
                  <label className="block font-semibold">Project</label>
                  <select
                    name="Project"
                    value={currentVersion.Project}
                    onChange={(e) =>
                      setCurrentVersion((prev) => ({
                        ...prev,
                        Project: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 p-2 rounded"
                  >
                    <option value="">Select Project</option>
                    {ProjectData.map((project) => (
                      <option key={project._id} value={project._id}>
                        {project.ProjectName}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block font-semibold">Version</label>
                  <input
                    type="text"
                    name="Version"
                    value={currentVersion.Version}
                    onChange={(e) =>
                      setCurrentVersion((prev) => ({
                        ...prev,
                        Version: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block font-semibold">Version Date</label>
                  <input
                    type="date"
                    name="VersionDate"
                    value={currentVersion.VersionDate}
                    onChange={(e) =>
                      setCurrentVersion((prev) => ({
                        ...prev,
                        VersionDate: e.target.value,
                      }))
                    }
                    className="w-full border border-gray-300 p-2 rounded"
                  />
                </div>

                <div className="flex justify-end space-x-2">
                  <button
                    type="button"
                    onClick={() => setShowUpdateModal(false)}
                    className="px-4 py-2 bg-gray-400 text-white rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default Add_Version;
